export default __webpack_public_path__ + "static/media/Nyla_Rodgers_AHV_In_Moms_We_Trust.80c6629b.jpg";